import { Component } from '@angular/core';

@Component({
  selector: 'app-split-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
})
export class TableComponent {}
